import { Component, effect, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
// components
import { TextSummarizerComponent } from '../text-summarizer/text-summarizer.component';
// services
import { CurrencyService } from '@app/core/shared/services/currency.service';
import { StorageService } from '@app/shared/services/storage.service';
// interfaces & enums
import { PriceType } from '@app/+products/shared/interfaces/product.interface';
import { CurrencyCodes } from '@app/shared/enums/currencies.enum';

@Component({
  selector: 'pwj-item-prices',
  standalone: true,
  imports: [TextSummarizerComponent, TranslateModule, DecimalPipe],
  templateUrl: './item-prices.component.html',
  styleUrl: './item-prices.component.scss',
})
export class ItemPricesComponent {
  public currentCurrency: keyof PriceType = CurrencyCodes.usd;
  // inputs
  basePrice = input<PriceType>();
  lowestPrice = input<PriceType>();
  highestPrice = input<PriceType>();
  summarizingLength = input<number>(20);

  // dependencies
  private readonly _storageService = inject(StorageService);
  private readonly _currencyService = inject(CurrencyService);

  constructor() {
    this.currentCurrency =
      this._storageService.getCurrency() as keyof PriceType;

    effect(() => {
      this.currentCurrency = this._currencyService.currentCurrency();
    });
  }
}
